define(["require", "exports", "./Alias", "./Aria", "./Declarative", "./DefaultSubmit", "./Dependency", "./Excluded", "./FieldStatus", "./Framework", "./Icon", "./Message", "./Sequence", "./SubmitButton", "./Tooltip", "./Trigger"], function (require, exports, Alias_1, Aria_1, Declarative_1, DefaultSubmit_1, Dependency_1, Excluded_1, FieldStatus_1, Framework_1, Icon_1, Message_1, Sequence_1, SubmitButton_1, Tooltip_1, Trigger_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = {
        Alias: Alias_1.default,
        Aria: Aria_1.default,
        Declarative: Declarative_1.default,
        DefaultSubmit: DefaultSubmit_1.default,
        Dependency: Dependency_1.default,
        Excluded: Excluded_1.default,
        FieldStatus: FieldStatus_1.default,
        Framework: Framework_1.default,
        Icon: Icon_1.default,
        Message: Message_1.default,
        Sequence: Sequence_1.default,
        SubmitButton: SubmitButton_1.default,
        Tooltip: Tooltip_1.default,
        Trigger: Trigger_1.default,
    };
});
